/**
 * Back in stock — capture demand on sold-out sizes.
 *
 * A greyed-out swatch tells a shopper we make her size and it is gone. This
 * turns that dead end into a signal: tap it, leave an email, and Klaviyo
 * notifies her when it returns. It also tells us which sizes to reorder.
 *
 * Posts to Klaviyo's public onsite endpoint, which takes the PUBLIC company
 * ID (the same one already in the page's Klaviyo script). No private key.
 */
(function() {
  'use strict';

  var panel = document.querySelector('[data-back-in-stock]');
  if (!panel) return;

  var company = panel.getAttribute('data-klaviyo-key');
  if (!company) return;

  var emailInput = panel.querySelector('input[type="email"]');
  var sizeLabel = panel.querySelector('[data-bis-size]');
  var msg = panel.querySelector('[data-bis-msg]');
  var closeBtn = panel.querySelector('[data-bis-close]');
  var submitBtn = panel.querySelector('.BackInStock__Button');

  // The theme prints the full product (with variants) as JSON already.
  var product = null;
  try {
    var node = document.querySelector('[data-product-json]');
    product = node ? JSON.parse(node.textContent).product : null;
  } catch (e) {}
  if (!product || !product.variants) return;

  var currentVariant = null;

  function selectedValues() {
    var chosen = {};
    document.querySelectorAll('.SizeSwatch__Radio:checked, .ColorSwatch__Radio:checked').forEach(function(r) {
      var pos = parseInt(r.getAttribute('data-option-position'), 10);
      if (pos) chosen[pos] = r.value;
    });
    return chosen;
  }

  /**
   * Resolve which variant the shopper means. With two size options the value
   * alone is ambiguous, so combine it with whatever else is already selected;
   * fall back to the first variant carrying that value.
   */
  function resolveVariant(position, value) {
    var chosen = selectedValues();
    chosen[position] = value;

    var exact = product.variants.filter(function(v) {
      return Object.keys(chosen).every(function(p) { return v['option' + p] === chosen[p]; });
    })[0];
    if (exact) return exact;

    return product.variants.filter(function(v) { return v['option' + position] === value; })[0] || null;
  }

  function setMessage(text, kind) {
    msg.textContent = text || '';
    msg.className = 'BackInStock__Msg' + (kind ? ' is-' + kind : '');
  }

  function open(label, variant) {
    currentVariant = variant;
    sizeLabel.textContent = label;
    setMessage('');
    emailInput.value = emailInput.value || '';
    panel.hidden = false;
    panel.classList.add('is-open');
    submitBtn.disabled = false;
    submitBtn.textContent = submitBtn.getAttribute('data-label') || 'Notify me';
    emailInput.focus({ preventScroll: true });
    panel.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
  }

  function close() {
    panel.classList.remove('is-open');
    panel.hidden = true;
    currentVariant = null;
  }

  // Sold-out swatches are disabled inputs, so the label click is ours to use.
  document.addEventListener('click', function(e) {
    var swatch = e.target.closest('.SizeSwatch--soldOut');
    if (!swatch) return;
    e.preventDefault();

    var position = parseInt(swatch.getAttribute('data-option-position'), 10);
    var value = swatch.getAttribute('data-value');
    var variant = resolveVariant(position, value);
    if (!variant) return;

    open(value, variant);
  });

  if (closeBtn) closeBtn.addEventListener('click', close);

  // Deliberately NOT a <form>: this panel sits inside the theme's product
  // form, and a nested form is invalid HTML — browsers drop the inner tag.
  function submit() {
    if (!currentVariant) return;

    var email = (emailInput.value || '').trim();
    if (!email || email.indexOf('@') < 1) {
      setMessage('Please enter a valid email address.', 'error');
      return;
    }

    submitBtn.disabled = true;
    submitBtn.textContent = 'Sending…';
    setMessage('');

    var body = new URLSearchParams();
    body.append('a', company);
    body.append('email', email);
    body.append('variant', currentVariant.id);
    body.append('product', product.id);
    body.append('platform', 'shopify');

    fetch('https://a.klaviyo.com/onsite/components/back-in-stock/subscribe', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded', 'Accept': 'application/json' },
      body: body.toString()
    })
      .then(function(r) { return r.json().catch(function() { return { success: r.ok }; }); })
      .then(function(data) {
        if (data && (data.success === true || data.success === undefined)) {
          submitBtn.textContent = 'Done ✓';
          setMessage("We'll email you the moment it's back.", 'success');
          setTimeout(close, 2600);
        } else {
          throw new Error('rejected');
        }
      })
      .catch(function() {
        submitBtn.disabled = false;
        submitBtn.textContent = submitBtn.getAttribute('data-label') || 'Notify me';
        setMessage("That didn't go through. Please try again.", 'error');
      });
  }

  submitBtn.addEventListener('click', submit);
  emailInput.addEventListener('keydown', function(e) {
    if (e.key === 'Enter') { e.preventDefault(); submit(); }
  });
})();
